import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'

// Pathless layout that OWNS the search-keyed queries (the list and the picked trace), so a filter or a
// pick re-keys THIS match and not the page above, whose skeleton would take the filter bar with it.
export const Route = createFileRoute('/_app/admin/traces/_list')({
  loaderDeps: ({ search }) => ({
    since: search.since,
    errors: search.errors,
    q: search.q,
    minMs: search.minMs,
    user: search.user,
    company: search.company,
    session: search.session,
    sessionAt: search.sessionAt,
    wide: search.wide,
    trace: search.trace,
    traceAt: search.traceAt,
  }),
  context: ({ deps }) => ({
    tracesInfiniteQueryOptions: trpc.admin.listTraces.infiniteQueryOptions(
      deps.session
        ? { session: { id: deps.session, at: deps.sessionAt, wide: deps.wide || undefined } }
        : {
            since: deps.since,
            errorsOnly: deps.errors || undefined,
            search: deps.q.trim() || undefined,
            minMs: deps.minMs || undefined,
            user: deps.user,
            company: deps.company,
          },
      { getNextPageParam: (page) => (page.ok ? page.nextCursor : undefined) },
    ),
    traceQueryOptions: deps.trace
      ? trpc.admin.getTrace.queryOptions({ traceId: deps.trace, at: deps.traceAt })
      : undefined,
  }),
  loader: ({ context }) => {
    context.queryClient.infiniteQuery(context.tracesInfiniteQueryOptions).catch(noop)
    if (context.traceQueryOptions) context.queryClient.query(context.traceQueryOptions).catch(noop)
  },
})
